/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisteredDevice } from '../../models/registered-device';
import { RegisteredDeviceCreateDto } from '../../models/registered-device-create-dto';

export interface CreateDevice$Params {
      body: RegisteredDeviceCreateDto
}

export function createDevice(http: HttpClient, rootUrl: string, params: CreateDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<RegisteredDevice>> {
  const rb = new RequestBuilder(rootUrl, createDevice.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegisteredDevice>;
    })
  );
}

createDevice.PATH = '/api/regdevice';
